import { ReactElement } from 'react'

import { SelectTags } from 'components/v2/SelectTags'
import { ISelectTagsProps } from 'components/v2/SelectTags/types'
import { RoutingProjectDow } from 'gql/generated/graphql'

interface ISelectDowProps extends Omit<ISelectTagsProps, 'items' | 'getTagLabel'> {
  values: RoutingProjectDow[]
  readOnlyValues?: RoutingProjectDow[]
  availableDows: RoutingProjectDow[]
  onChange: (values: RoutingProjectDow[]) => void
}

export const SelectDow = ({
  values,
  readOnlyValues = [],
  availableDows,
  onChange,
  ...props
}: ISelectDowProps): ReactElement => {
  const shownItems = availableDows.filter((item) => !values.includes(item))
  return (
    <SelectTags
      values={values}
      readOnlyValues={readOnlyValues}
      onChange={onChange}
      {...props}
      items={shownItems}
      getTagLabel={function (dow: RoutingProjectDow): string {
        return dow
      }}
    />
  )
}
